import React, { memo, forwardRef } from "react";
const SvgCapitalOmega = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M13.76 19.648c.496.208.744.608.744 1.2v2.304c0 .768-.392 1.152-1.176 1.152h-4.2c-.416 0-.712-.104-.888-.312-.16-.224-.24-.448-.24-.672 0-.24.08-.464.24-.672.176-.208.472-.312.888-.312h3.504v-1.368c-1.424-.416-2.52-1.216-3.288-2.4-.768-1.184-1.152-2.552-1.152-4.104 0-2.144.752-3.92 2.256-5.328C11.968 7.712 13.808 7 15.968 7c2.176 0 4.008.704 5.496 2.112 1.504 1.392 2.256 3.16 2.256 5.304 0 1.584-.376 2.968-1.128 4.152-.752 1.168-1.856 1.968-3.312 2.4v1.368h3.504c.416 0 .704.104.864.312.16.208.24.432.24.672 0 .224-.08.448-.24.672-.16.208-.448.312-.864.312H18.56c-.784 0-1.176-.384-1.176-1.152v-2.304c0-.608.256-1.008.768-1.2 1.104-.4 1.936-1.048 2.496-1.944.56-.896.84-1.944.84-3.144 0-1.584-.52-2.904-1.56-3.96-1.04-1.072-2.352-1.608-3.936-1.608s-2.904.536-3.96 1.608c-1.04 1.072-1.56 2.4-1.56 3.984 0 2.56 1.096 4.248 3.288 5.064z"
      />
    </svg>
  );
});
SvgCapitalOmega.displayName = "SvgCapitalOmega";
const MemoForwardRef = memo(SvgCapitalOmega);
export default MemoForwardRef;
